import * as AT from '../constants/actionTypes'

/**
 * Address reducer
 * @param {*} state 
 * @param {*} action 
 */
function address(state = { addresses: [], addressesByLicense: [] }, action) {
	switch (action.type) {
		case AT.PROFILE_LOGOUT:
			return Object.assign({}, state, {
				addressesByLicense: [],
				addresses: [],
			})		
		case AT.ADDRESS_LIST_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				addresses: [],
				error: undefined
			})
		case AT.ADDRESS_LIST_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.ADDRESS_LIST_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				addresses: action.payload.addresses,
				error: undefined
			})
		case AT.ADDRESS_LIST_BY_LICENSE_LOADING_STARTED:
			return Object.assign({}, state, {
				isLoading: true,
				addressesByLicense: [],
				error: undefined
			})
		case AT.ADDRESS_LIST_BY_LICENSE_LOADING_FAILED:
			return Object.assign({}, state, {
				isLoading: false,
				error: action.payload.error
			})
		case AT.ADDRESS_LIST_BY_LICENSE_LOADING_FINISHED:
			return Object.assign({}, state, {
				isLoading: false,
				addressesByLicense: action.payload.addresses,
				error: undefined
			})
		case AT.ADDRESS_UI_CLEAR:
			return Object.assign({}, state, {
				error: undefined
			})
		default:
			return state;
	}
}

export default address;